import "../scss/header.scss"
const Header = () => {
  return (
    <header >
      <img src="https://cdn.pixabay.com/photo/2017/04/20/01/43/bubble-2244298_1280.png" alt="logo" />
      <h1>COMMENTS</h1>
    </header>
  )
}

export default Header
